import { TableConditionApi } from 'cadenza/api-client/conditions/table-condition-api';
import type { ConditionApiOptions } from 'cadenza/api-client/conditions/condition-api';

export class TreeConditionApi extends TableConditionApi {

  constructor (options: ConditionApiOptions) {
    super(options, '/treeConditionQuery');
  }

}
